import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { PublicVisitBroadcastDetailsTypes } from "../../../../messages/Visit";
import { Visit } from "../../../../system/AppState/AppVisitsState";
import { formatDate, formatDayOfWeek, formatTimes } from "../../../../utils/dateUtils";
import { withDefault } from "../../../../utils/withDefault";
import { AppList, AppListItem } from "../../../Generic/AppList";

export type SinglesVisit = Visit.Available & {
  publicVisitBroadcastDetails: PublicVisitBroadcastDetailsTypes.Singles;
};

interface Props {
  visit: SinglesVisit;
}

export const PendingConfirmationVisitDatesSingles = ({ visit }: Props) => {
  const pendingConfirmationInstances = withDefault(
    visit.caregiverVisitEngagementDetails.pendingConfirmationInstances,
    []
  );

  return (
    <AppList>
      {pendingConfirmationInstances.map(({ startTime, endTime }) => (
        <AppListItem
          key={startTime.toString()}
          title={formatDateString(startTime)}
          trailing={formatTimeString(startTime, endTime)}
        />
      ))}
    </AppList>
  );
};

const formatDateString = (dateTime: LocalDateTime) =>
  `${formatDate(dateTime.toLocalDate(), "MM/dd/yy")} ${formatDayOfWeek(dateTime.dayOfWeek())}`;

const formatTimeString = (startTime: LocalDateTime, endTime: LocalDateTime) =>
  formatTimes({ startAt: startTime.toLocalTime(), endAt: endTime.toLocalTime() });
